export default __webpack_public_path__ + "static/O0086-fc4f56abe73802dfc3d797053296e7cc.png";